/**
 *  @class
 *  @function ImageTextOverlay
 */

if (!customElements.get('image-with-text-overlay')) {
  class ImageTextOverlay extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
      this.img = this.querySelector('.image-with-text-overlay--bg img');
    }
    connectedCallback() {
      // Cache once — reused in disconnectedCallback
      this.animationsEnabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      if (this.animationsEnabled) {
        this.prepareAnimations();
      }
      window.addEventListener('load', () => {
        if (this.img) {
          lazySizes.loader.unveil(this.img);
        }
      });
    }
    disconnectedCallback() {
      // Guard against disconnecting before fonts.ready resolves
      if (this.tl) this.tl.kill();
      if (this.splittext) this.splittext.revert();
    }
    prepareAnimations() {
      const section = this;

      // Cache element refs up-front — avoids repeated querySelector calls below
      const bg           = section.querySelector('.image-with-text-overlay--bg');
      const badge        = section.querySelector('.inline-badge');
      const subheading   = section.querySelector('.subheading');
      const contentInner = section.querySelectorAll('.image-with-text-overlay--content-inner');
      const headingAndRte = section.querySelectorAll('.image-with-text-overlay--heading, .rte p');
      const buttons      = section.querySelectorAll('.button');

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top center"
        }
      });

      document.fonts.ready.then(() => {
        gsap.set(contentInner, { visibility: 'visible' });

        // headingAndRte cached above — reused for both SplitText passes
        section.splittext = new SplitText(headingAndRte, {
          type: 'lines',
          linesClass: 'line-child'
        });
        section.mask = new SplitText(headingAndRte, {
          type: 'lines',
          linesClass: 'line-parent'
        });

        // .line-child elements only exist after SplitText runs — query here
        const headingLines = section.querySelectorAll('.image-with-text-overlay--heading .line-child');
        const bodyLines    = section.querySelectorAll('.rte p .line-child');

        // Single fluent chain — no repeated section.tl assignments
        section.tl
          .from(bg, { scale: 1.2, duration: 1 })
          .fromTo(badge,     { opacity: 0 }, { duration: 0.25, opacity: 1 }, '>-=0.15')
          .fromTo(subheading, { opacity: 0 }, { duration: 0.5,  opacity: 1 }, '>-=0.3')
          .from(headingLines, { duration: 0.75, yPercent: '100', stagger: 0.05, rotation: '2deg' }, '>-=0.3')
          .from(bodyLines,    { duration: 0.5,  yPercent: '100', stagger: 0.02 }, '>-=0.3');

        // buttons.length fixes the always-truthy querySelectorAll() guard
        // forEach index replaces manual counter: (i-1)*0.1 === i*0.1 with 0-based index
        if (buttons.length) {
          buttons.forEach((btn, i) => {
            section.tl.fromTo(btn, { autoAlpha: 0 }, { duration: 0.5, autoAlpha: 1 }, `>-=${i * 0.1}`);
          });
        }
      });

      const parallaxEls = section.querySelectorAll('.thb-parallax-image');
      if (parallaxEls.length) {
        gsap.fromTo(parallaxEls, { y: '-8%' }, {
          y: '8%',
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            scrub: 1,
            // Static string — no arrow function wrapper needed
            start: "top bottom",
            // Inline computation removes the onUpdate + property variable pattern.
            // GSAP calls end() when refreshing scroll bounds, so it's always current.
            end: () => `bottom top+=${gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")}px`
          }
        });
      }

      if (Shopify.designMode) {
        section.tl.scrollTrigger.refresh();
      }
    }
  }
  customElements.define('image-with-text-overlay', ImageTextOverlay);
}
